import axios, { AxiosRequestConfig } from 'axios';
import type { ReactionCounts } from '../types/api';

const createConfig = (accessToken: string): AxiosRequestConfig => ({
    headers: { 'Authorization': `Bearer ${accessToken}`, 'AccessToken': accessToken, 'Content-Type': 'application/json' },
});

export interface ToggleReactionInput { targetType: 'note' | 'comment'; targetId: string; emoji: string }

/** Client de `POST /api/reactions/toggle` (C10 SP3). Les compteurs à lire viennent de `notes/{id}/comments`. */
export const reactionsService = {
    toggle: async (input: ToggleReactionInput, accessToken: string): Promise<{ active: boolean; counts: ReactionCounts }> => {
        const response = await axios.post('/api/reactions/toggle', input, createConfig(accessToken));
        return response.data.data;
    },
};

export default reactionsService;
